let _ = require('lodash')
let moment = require('moment')
let { billingFrequencies } = require('./constants')
let ota = big => _.map(big, (o, id) => ({ ...o, id })) //object to array
// yay to https://hackernoon.com/rethinking-javascript-eliminate-the-switch-statement-for-better-code-5c81c044716d
let executeIfFunction = f => (typeof f === 'function' ? f() : f)
let switchcase = cases => defaultCase => key =>
  // eslint-disable-next-line no-prototype-builtins
  cases.hasOwnProperty(key) ? cases[key] : defaultCase
// const switchcaseF = cases => defaultCase => key => executeIfFunction(switchcase(cases)(defaultCase)(key))

let switchy = (key, cases) =>
  executeIfFunction(switchcase(cases)(cases.default)(key))

let getBillingCycleDateValue = ({
  year,
  month,
  billingFrequency = billingFrequencies.semimonthly,
  billingCycle = undefined,
}) => {
  // 2019-01B0 = January 2019, Billing cycle 0, aka Jan 1-14, 2019
  // 2019-01B1 = January 2019, Billing cycle 1, aka Jan 15-31, 2019
  // remember that cockeyed +1 cuz months are 0-indexed!

  let monthString = `${moment().year(year).month(month).format('YYYY-MM')}`

  return switchy(billingFrequency, {
    [billingFrequencies.semimonthly]: () => `${monthString}B${billingCycle}`,
    [billingFrequencies.monthly]: () => monthString,
  })
}

let parseBillingCycleDateValue = str => {
  let [yearMonth, billingCycle = ''] = str.split('B')
  let mo = moment(yearMonth, 'YYYY-MM')
  let billingFrequency = !billingCycle
    ? billingFrequencies.monthly
    : billingFrequencies.semimonthly

  return {
    year: mo.year(),
    month: mo.month(),
    billingCycle: _.parseInt(billingCycle),
    billingFrequency,
  }
}

let getPrettyBillingRange = value => {
  let { month, year, billingCycle, billingFrequency } =
    parseBillingCycleDateValue(value)
  let mo = moment().month(month).year(year)
  let lastDayOfMonth = moment(mo).endOf('month').date()
  return switchy(billingFrequency, {
    semimonthly: () =>
      billingCycle === 0
        ? mo.format('MMM 1-14, YYYY')
        : mo.format(`MMM 15-${lastDayOfMonth}, YYYY`),
    monthly: () => mo.format(`MMM 1-${lastDayOfMonth}, YYYY`),
  })
}

let getBillingTime = billingCycleDateValue => {
  let prettyRange = getPrettyBillingRange(billingCycleDateValue)
  let [yearMonth, billingCycle] = billingCycleDateValue.split('B')
  let from
  let to

  if (_.isUndefined(billingCycle)) {
    // is monthly
    from = moment(yearMonth, 'YYYY-MM').startOf('month')
    to = from.clone().endOf('month')
  } else if (billingCycle === '0') {
    from = moment(yearMonth, 'YYYY-MM').startOf('month')
    to = from.clone().date(14).endOf('day')
  } else if (billingCycle === '1') {
    from = moment(yearMonth, 'YYYY-MM').startOf('month').date(15)
    to = from.clone().endOf('month')
  } else {
    throw new Error(`Invalid billing cycle value: ${billingCycle}`)
  }

  return {
    from,
    to,
    prettyRange,
    yearMonth,
    billingCycleDateValue,
  }
}

module.exports = {
  switchy,
  ota,
  getBillingCycleDateValue,
  parseBillingCycleDateValue,
  getPrettyBillingRange,
  getBillingTime,
}
